import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Wrapper = styled.section`
  ${tw`max-w-5xl mx-auto pb-8 md:pb-16 px-8`}
`

const Image = ({ data: { largeImage: image } = {} }) => {
  const title = image?.title || ''
  const imageGatsbyData = getImage(image?.localFile.childImageSharp.gatsbyImageData)
  return <Wrapper>{image && <GatsbyImage image={imageGatsbyData} alt={title} />}</Wrapper>
}

export default Image

Image.propTypes = {
  data: PropTypes.object,
}

export const imageData = graphql`
  fragment Image on WpPage_Pagebuilder_Layouts_Image {
    largeImage: image {
      localFile {
        childImageSharp {
          gatsbyImageData(width: 960)
        }
      }
      title
    }
    fieldGroupName
  }
`
